import PropTypes from 'prop-types';
import { useEffect } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import AuthorizeAlert from './AuthorizeAlert';
import AuthorizeInfo from './AuthorizeInfo';
import Tracker from '../utils/usageTracker';
import ApplicationAuthorization, { LISTING_STATUS } from '../data/models/ApplicationAuthorization';
import { RequestStatusPropType } from '../data/models/RequestStatus';
import { useSelector } from 'react-redux';
import { getHasIntegrationsManagementWrite } from '../selectors/ScopeSelectors';
import { isOnlyRequestingOAuthScope } from '../utils/urls';
import { getApplicationAuthorizationData, getIsRequestingNewScopes } from '../selectors/AppSelectors';
import { EVENTS } from '../constants/Events';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "AuthorizeBody__Wrapper",
  componentId: "sc-1tsypdi-0"
})(["max-width:720px;"]);
const AuthorizeBody = ({
  authorizationData,
  authorizationDataStatus,
  isInternallyDeveloped
}) => {
  const hasIntegrationsManagementWrite = useSelector(getHasIntegrationsManagementWrite);
  const app = useSelector(getApplicationAuthorizationData);
  const location = useLocation();
  const cannotInstall = !hasIntegrationsManagementWrite && !isOnlyRequestingOAuthScope(location.search);
  const isRequestingNewScopes = useSelector(getIsRequestingNewScopes);
  useEffect(() => {
    if (app && !app.authorized) {
      Tracker.track(EVENTS.AUTHORIZE_VIEW, {
        applicationId: app.appId,
        applicationName: app.name,
        domainVerificationStatus: app.getDomainVerificationStatus(),
        listingStatus: app.getListingStatus(),
        scopeGroupCount: app.scopeGroups.length,
        scopeGroups: app.scopeGroups.map(sg => sg.name),
        hasInstallPermission: !cannotInstall,
        redirected: false,
        clientId: app.clientId,
        isRequestingNewScopes: !!isRequestingNewScopes
      });
    }
  }, [app, cannotInstall, isRequestingNewScopes]);
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [(authorizationData.getListingStatus() === LISTING_STATUS.UNLISTED && !isInternallyDeveloped || cannotInstall) && /*#__PURE__*/_jsx(AuthorizeAlert, {
      domainStatus: authorizationData.getDomainVerificationStatus(),
      cannotInstall: cannotInstall
    }), /*#__PURE__*/_jsx(AuthorizeInfo, {
      appId: authorizationData.appId,
      authorizationData: authorizationData,
      authorizeStatus: authorizationDataStatus,
      providerName: authorizationData.name,
      providerDomain: authorizationData.provider.verified ? authorizationData.provider.domain : null
    })]
  });
};
AuthorizeBody.propTypes = {
  authorizationDataStatus: RequestStatusPropType.isRequired,
  authorizationData: PropTypes.instanceOf(ApplicationAuthorization).isRequired,
  isInternallyDeveloped: PropTypes.bool.isRequired
};
export default AuthorizeBody;